import { render, staticRenderFns } from "./TitleTextPreview.vue?vue&type=template&id=2968d34c&scoped=true"
import script from "./TitleTextPreview.vue?vue&type=script&lang=js"
export * from "./TitleTextPreview.vue?vue&type=script&lang=js"
import style0 from "./TitleTextPreview.vue?vue&type=style&index=0&id=2968d34c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2968d34c",
  null
  
)

export default component.exports